import React from "react";
import { Button, dialog, InfiniteScroll, Progress } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import Search from "../../../../../components/Search";
import BaseListPage from "../../../../../base/BaseListPage";
import InputFactory from "../../../../../components/InputFactory";
import { toDisplayCase } from "nq-component";
import NavBar from "../../../../../components/navbar";
import Table from "../../../../../components/Table";
import CollapseView from "./components/CollapseView";
import DialogModal from "../../../../../components/Dialog";
import RightSidebar from "../../../../../components/RightSidebar";
import WasteProductPresenter from "./WasteProductPresenter";

class WasteProductPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new WasteProductPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: true,
      total: 0,
      count: 0,
      range: "",
      showMobileFilters: false,
    };
  }

  getCollectionName() {
    return "waste_records";
  }

  closeDialog() {
    dialog.close();
  }

  onClickImport() {
    this.presenter.onClickImport();
  }

  onClickExport() {
    this.presenter.onClickExport();
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.searchSubmit(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onClickAdd() {
    this.presenter.onClickAdd();
  }
  onClickEdit(index) {
    this.presenter.onClickEdit(index);
  }
  onClickDelete(index) {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-exclamation-octagon-fill"
          iconColor="red"
          title="Confirm Deletion"
          message="This will remove the selected data from the system. Are you sure want to continue?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onClickDelete(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onClickCancelRequest(index) {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm Cancellation"
          message="Are you sure want to cancel this request?"
          isCancelButton={true}
          onSubmit={() => this.presenter.onCancelSubmit(index)}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onReceiveModal(index) {
    dialog.fire({
      html: (
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="m-0 fw-bold">Confirm Receiving Items</h5>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => dialog.close()}
            />
          </div>
          <hr />
          <p className="mb-4">
            How would you like to receive the items? You can choose to receive
            all or partially receive.
          </p>

          <div className="d-flex justify-content-center gap-2">
            <button
              className="btn"
              style={{ backgroundColor: "#d1d1d1", color: "black" }}
              onClick={() => this.presenter.onPartialReceive(index)}
            >
              Partial Receive
            </button>
            <button
              className="btn text-white"
              style={{ backgroundColor: "#82c14a" }}
              onClick={() => this.presenter.onReceiveAll(index)}
            >
              Receive All
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCancelButton: false,
      footer: false,
    });
  }

  onClickUpsale(index) {
    const object = this.state.objects[index];
    this.presenter.onClickUpsale(object);
  }

  onClickView(index) {
    this.presenter.onClickView(index);
  }

  onCollapse(index) {
    const stock = this.state.objects[index];
    return (
      <CollapseView
        stock={stock}
        onUpsale={() => this.onClickUpsale(index)}
        onEdit={() => this.onClickView(index)}
        onReceiveModal={() => this.onReceiveModal(index)}
        onDelete={() => this.onClickDelete(index)}
      />
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, loading } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <NavBar />
        <RightSidebar
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          range={this.state.range}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!loading && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1
                  className="fw-bold text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  {/* {schema.label || toDisplayCase(this.getCollectionName())} */}
                  Waste Products
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <Search
                  schemas={this.getSchemas()}
                  className="mt-3"
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
                <div className="text-nowrap mt-3">
                  <i
                    className="bi bi-filter fs-1"
                    onClick={() => this.setState({ showMobileFilters: true })}
                    style={{ color: "#83c14a" }}
                  ></i>
                </div>
              </div>
              <Table
                fields={schema.fields}
                objects={objects}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "password",
                    "storeId",
                    "requestNumber",
                    "requestedBy",
                    "remarks",
                    "destinationLocation",
                  ]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onCollapse={this.onCollapse.bind(this)}
                //  progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3"
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(WasteProductPage);
